// A printed deck drawn in CSS: a tuck box with real cards from the pack fanned out behind it.
import type { ShopProduct } from '@shared/types';

const VARIANTS: Record<string, string> = { 'classic-box': 'blue', 'shaadi-box': 'rose', 'family-deck': 'marigold' };

function Blanked({ text }: { text: string }) {
  const parts = text.split(/_{3}/);
  return (
    <>
      {parts.map((p, i) => (
        <span key={i}>
          {p}
          {i < parts.length - 1 && <span className="dm-blank" />}
        </span>
      ))}
    </>
  );
}

export function DeckMock({ product, size = 'md' }: { product: ShopProduct; size?: 'md' | 'lg' }) {
  const variant = VARIANTS[product.slug] ?? (product.kind === 'custom_deck' ? 'marigold' : 'blue');
  const custom = product.kind === 'custom_deck';
  const prompt = product.sample.prompt ?? 'Diwali at our house is never complete without ___.';
  const answer = product.sample.answers[0] ?? 'Mummy on speakerphone';
  return (
    <div className={`deck-mock v-${variant} ${size}`} aria-hidden="true">
      <div className="dm-card dm-prompt">
        <Blanked text={prompt} />
        <span className="dm-mark">CompleteMasti</span>
      </div>
      {custom ? (
        <div className="dm-card dm-answer dm-custom">
          <span className="dm-photo">📸</span>
          Your family's inside joke here
          <span className="dm-mark">CompleteMasti</span>
        </div>
      ) : (
        <div className="dm-card dm-answer">
          {answer}
          <span className="dm-mark">CompleteMasti</span>
        </div>
      )}
      <div className="dm-box">
        <span className="dm-lid" />
        <img src="/logo-mark.png" alt="" className="dm-logo" />
        <span className="dm-name">{product.name.replace(/^CompleteMasti /, '')}</span>
        <span className="dm-count">{custom ? 'Your cards + Classic' : `${product.cardCount.toLocaleString()} cards`}</span>
      </div>
    </div>
  );
}
